var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"paas-enum-show-container"},[_vm._v(" "+_vm._s(_vm.showData)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }